import React from 'react';
import { asField } from 'informed';
import classnames from 'classnames';
import { map } from 'lodash';
import RawInputSummernote from './RawInputSummernote';

export default asField(({
  fieldState, fieldApi, disabled, field, label, col, required, ...props
}) => (
  <div className={classnames('text-input-form-state form-group', col, { required, 'has-error': fieldState.error })}>
    <label style={{
        color:'#4A4F58',
        fontFamily: 'Public Sans',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '0em',
        textAlign: 'left',
  }}  htmlFor={field}>{label}</label>
    <RawInputSummernote value={fieldState.value} onChange={fieldApi.setValue} disabled={disabled} {...props} />
    {map(fieldState.error, e => <p key={e} className="text-danger">{e}</p>)}
  </div>
));
